<!-- CONTACT PAGE -->
<div class="container">

  <!-- HEADER PAGE -->

  <!-- ROW TITLE -->
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="60" fxFlex.lg="60" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">
      <!-- TITLE -->
      <div class="title alicent">
        Let's get in touch
      </div>
    </div>

  </div>

  <div fxLayout="row wrap" fxLayoutAlign="center">
    <div fxFlex.xl="30" fxFlex.lg="30" fxFlex.md="60" fxFlex.sm="60" fxFlex.xs="90">

      <!-- WARNING -->
      <div class="btncontainer buttons">
        <button mat-flat-button class="btn-hover color-3">
          <a href="mailto:support@edclin.com">
            Email us
          </a>
        </button>
      </div>

      <!-- WARNING -->
      <div class="btncontainer buttons">
        <button mat-flat-button class="btn-hover color-3">
          <a href="tel:+33147351717">
            Call us
          </a>
        </button>
      </div>

    </div>
  </div>
</div>

<app-footer></app-footer>
